import BottomSheet from '@/components/core/bottom-sheet/bottom-sheet';
import { chatBot } from '@/constants/pages';
import { promptData } from '@/constants/prompt';
import { useMixedPanel } from '@/hooks/useMixPanel';
import { Box, SxProps, Typography } from '@mui/material';
import { IconSparkles } from '@tabler/icons-react';
import { forwardRef, useImperativeHandle, useState } from 'react';
import ChatBot from '.';
import AnimatedVaniButton from './animatedVaniButton';

type ChatSectionProps = {
  isLoading: boolean;
  page: string;
  sx?: SxProps;
};

export type ChatSectionRef = {
  setPosition(position: 'top' | 'bottom'): void;
  setIsChatOpen(isChatOpen: boolean): void;
};

const ChatSection = forwardRef<ChatSectionRef, ChatSectionProps>(
  ({ isLoading, page, sx }, ref) => {
    const { trackEvent } = useMixedPanel();
    const [isChatOpen, setIsChatOpen] = useState(false);
    const [position, setPosition] = useState<'top' | 'bottom'>('bottom');

    useImperativeHandle(ref, () => ({
      setPosition,
      setIsChatOpen,
    }));

    const handleChatClose = () => {
      trackEvent('CLICK: Closed Chat Bot');
      setIsChatOpen(false);
    };

    const getFormattedPromptData = (page: string) => {
      if (!page) return [];
      return promptData[page as keyof typeof promptData];
    };
    return (
      <>
        <Box
          position={position === 'top' ? 'absolute' : 'fixed'}
          sx={{
            right: {
              xs: 8,
              sm: 32,
              lg:
                position === 'top'
                  ? 'calc((100vw - 1420px) / 2)'
                  : 'calc((100vw - 1134px) / 2)',
            },
            display: 'flex',
            alignItems: 'center',
            cursor: 'pointer',
            // ...(position === 'top' && { top: { xs: 15, sm: 20 } }),
            // ...(position === 'bottom' && { bottom: 15 }),
            bottom: 15,
            ...sx,
          }}
          onClick={() => {
            trackEvent('CLICK: Chat Bot');
            setIsChatOpen(true);
          }}
        >
          <AnimatedVaniButton isLoading={isLoading} />
        </Box>
        <BottomSheet
          isOpen={isChatOpen}
          headerBgColor='custom.chatBotLLM.headerBgColor'
          onClose={() => {
            handleChatClose();
          }}
          title={
            <Box
              display='flex'
              width='100%'
              justifyContent='center'
              alignItems='center'
            >
              <Typography
                variant='h6'
                display='flex'
                alignItems='center'
                width='70px'
                justifyContent={'space-between'}
              >
                {chatBot.title} <IconSparkles />
              </Typography>
              <Box
                sx={{
                  padding: '5px',
                  backgroundColor: '#ffffff33',
                  height: 'min-content',
                  display: 'flex',
                  marginLeft: '5px',
                  borderRadius: '4px',
                }}
              >
                <Typography
                  variant='caption'
                  fontFamily='monospace'
                  color='#ffffff'
                  lineHeight={1}
                  fontWeight={700}
                  fontSize='12px'
                >
                  BETA
                </Typography>
              </Box>
            </Box>
          }
          maxHeight='90vh'
        >
          <ChatBot promptData={getFormattedPromptData(page)} />
        </BottomSheet>
      </>
    );
  },
);

ChatSection.displayName = 'ChatSection';

export default ChatSection;
